<template>
  <div class="observation-description-plot">
    <font-awesome-icon icon="info" class="icon" />
    <span v-for="(t, i) in text" :key="i" style="display: block;">{{ t }}</span>
  </div>
</template>
<script>
// import format from '@/utils/format.js'

export default {
  name: 'ObservationDescription',
  props: {
    data: Array,
    plotType: String
  },
  computed: {
    text () {
      return this.data.map(d => d.plotData[this.$store.getters.activeLang.code])
    }
  }
}
</script>
<style>
.observation-description-plot {
  padding: 15px;
  padding-left: 50px;
  box-sizing: border-box;
}
.observation-description-plot > .icon {
  font-size: 30px;
  color: #371ea3;
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%) translateY(-15px);
}
</style>
